import Splide from '@splidejs/splide'
import Alpine from 'alpinejs'

export const initShowsSlider = () => {
    Alpine.data('initShowSlider', () => ({
        init() {
            new Splide(this.$el, {
                isNavigation: false,
                arrows: true,
                pagination: false,
                perMove: 1,
                updateOnMove: true,
                trimSpace: false,
                focus: 0,
                mediaQuery: 'min',
                lazyLoad: 'sequential',
                breakpoints: {
                    0: {
                        perPage: 1.1,
                        gap: 15,
                    },
                    695: {
                        perPage: 2.2,
                        gap: 30,
                    },
                    1400: {
                        perPage: 3.2,
                    },
                    1850: {
                        perPage: 3,
                    },
                },
            }).mount()
        },
    }))
}
